import { render, staticRenderFns } from "./EmailRepliedToNotification.vue?vue&type=template&id=3336f0ae&scoped=true&"
import script from "./EmailRepliedToNotification.vue?vue&type=script&lang=js&"
export * from "./EmailRepliedToNotification.vue?vue&type=script&lang=js&"
import style0 from "./EmailRepliedToNotification.vue?vue&type=style&index=0&id=3336f0ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3336f0ae",
  null
  
)

export default component.exports